import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'vue-lodash';
//import VueYandexMetrika from 'vue-yandex-metrika';
import App from '@/App';
import api from '@/api';
import router from '@/router';
import store from '@/store';
// import './registerServiceWorker';
import '@/filters/humanize';
import '@/filters/wordEnding';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueSimpleAlert from "vue-simple-alert";

Vue.config.productionTip = false;
Vue.component(VueQrcode.name, VueQrcode);
Vue.prototype.$api = api;
Vue.use(Vuex);
Vue.use(VueSimpleAlert);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');